/* eslint-disable no-plusplus */
import { fabric } from 'fabric';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHandleGroupDrawing } from '../../../redux/board/reducer';
import { applyBrushToCanvas, eventBus, generateId, getCurrentState, getPatternBrush } from '../../../utils';

export default () => {
  const dispatch = useDispatch();
  const canvasDrawingMode = useSelector((appState) => appState.board.canvasDrawingMode);
  const drawingObj = useSelector((appState) => appState.board.drawingObj);
  const handleGroupDrawing = useSelector((appState) => appState.board.handleGroupDrawing);
  const [state, _setState] = useState({
    canvas: null,
  });

  const initCanvas = (canvas) => _setState({ canvas });

  const addItemToGroupDrawing = () => {
    if (canvasDrawingMode) {
      eventBus.emit('save-canvas-state', getCurrentState());
    }
  };

  const onDrawingCancel = () => {
    if (handleGroupDrawing.length) {
      let i = handleGroupDrawing.length;
      if (canvasDrawingMode) {
        eventBus.emit('disable-cancel-btn');
        dispatch(setHandleGroupDrawing([]));
      }
      setTimeout(() => {
        while (i > 0) {
          const obj = state.canvas.getObjects()[window.canvas.getObjects().length - 1];
          if (obj) {
            state.canvas.remove(obj);
            state.canvas.renderAll();
          }
          i--;
        }
      }, 200);
    }
  };

  useEffect(() => {
    const { canvas } = state;
    if (canvas) {
      canvas.on('mouse:down', addItemToGroupDrawing);
      eventBus.on('on-drawing-cancel', onDrawingCancel);
    }
    return () => {
      if (canvas) {
        canvas.off('mouse:down', addItemToGroupDrawing);
        eventBus.off('on-drawing-cancel', onDrawingCancel);
      }
    };
  }, [handleGroupDrawing, canvasDrawingMode]);

  useEffect(() => {
    const { canvas } = state;
    if (canvas) {
      if (canvasDrawingMode) {
        canvas.isDrawingMode = true;
        canvas.freeDrawingBrush = getPatternBrush(canvas, drawingObj);
        applyBrushToCanvas(canvas.freeDrawingBrush, drawingObj);
      } else {
        canvas.isDrawingMode = false;
        if (handleGroupDrawing.length) {
          const group = new fabric.Group(handleGroupDrawing);
          group.set({
            id: generateId(),
          });
          canvas.add(group);
          handleGroupDrawing.map((item) => canvas.remove(item));
        }
        dispatch(setHandleGroupDrawing([]));
      }
    }
  }, [canvasDrawingMode, drawingObj]);

  return {
    initCanvas,
  };
};
